import { PaymentDetailType } from 'anchor-scout-common/types';
const PAYMENT_APPLIED_DETAIL_TYPES = new Set([
    PaymentDetailType.PaymentScheduled,
    PaymentDetailType.PaymentAwaitingInitiation,
    PaymentDetailType.PaymentInitiated,
    PaymentDetailType.PaymentCollected
]);
export function fromInvoice(param) {
    let { paymentMethodDisplay, paymentDetails } = param;
    if (paymentMethodDisplay != null) {
        return {
            kind: 'set',
            type: paymentMethodDisplay.type,
            last4: paymentMethodDisplay.last4
        };
    }
    if (paymentDetails.some((d)=>d.type === PaymentDetailType.MissingPaymentMethod)) {
        return {
            kind: 'notSet'
        };
    }
    if (paymentDetails.some((d)=>d.type === PaymentDetailType.PaymentMethodNotVerified)) {
        return {
            kind: 'unverified'
        };
    }
    if (paymentDetails.some((d)=>PAYMENT_APPLIED_DETAIL_TYPES.has(d.type))) {
        return {
            kind: 'pendingDetails'
        };
    }
    return {
        kind: 'notSet'
    };
}
export function fromRelationshipFundingSource(fundingSource) {
    if (fundingSource == null) {
        return {
            kind: 'notSet'
        };
    }
    const last4 = fundingSource.last4();
    if (last4 == null || last4 === '') {
        return {
            kind: 'pendingDetails'
        };
    }
    return {
        kind: 'set',
        type: fundingSource.isCreditCard() ? 'creditCard' : 'ach',
        last4
    };
}
